import { useTranslation } from "react-i18next";

import {
  ErrorMessage,
  ErrorMessageSpan,
  ErrorPage
} from "pstat-design-system/ErrorPages";

const StartSessionErrorPage = props => {
  const errorType = window.ERROR_TYPE;
  if (errorType === "catalix_login_error") {
    return <CatalixLoginError />;
  }
  return <CatalixLoginError />;
};

const CatalixLoginError = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage>
      <ErrorMessage
        id="error-title"
        title={t("errorPages.catalix.startSession.title")}
      >
        <ErrorMessageSpan id="error-message" mb={5}>
          {t("errorPages.catalix.startSession.error.message")}
        </ErrorMessageSpan>
        <ErrorMessageSpan id="error-suggestions" mb={5}>
          {t("errorPages.catalix.startSession.error.suggestions")}
        </ErrorMessageSpan>
      </ErrorMessage>
    </ErrorPage>
  );
};

export default StartSessionErrorPage;
